import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homeData';

export default function FeaturedGrid() {
  const mainArticle = featuredArticles[0];
  const sideArticles = featuredArticles.slice(1, 3);
  const bottomArticles = featuredArticles.slice(3, 5);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            最新<span className="text-primary-500">爆料</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">一手大瓜，实时更新，不错过任何一个热点</p>
        </div>

        {/* Main Layout */}
        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          {/* Left Large Card */}
          <Link
            to={`/article/${mainArticle.id}`}
            className="group relative w-full lg:w-[55%] rounded-2xl overflow-hidden cursor-pointer"
          >
            <div className="relative aspect-[4/5] lg:aspect-auto lg:h-[520px]">
              <img
                src={mainArticle.imageUrl}
                alt={mainArticle.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

              {/* Content Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold mb-3">
                  {mainArticle.tag}
                </span>
                <h3 className="font-heading text-xl md:text-2xl text-white mb-2 group-hover:text-accent-300 transition-colors line-clamp-2">
                  {mainArticle.title}
                </h3>
                <p className="text-white/60 text-sm line-clamp-2 mb-3 hidden md:block">
                  {mainArticle.excerpt}
                </p>
                <div className="flex items-center gap-4 text-white/50 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(mainArticle.views / 10000).toFixed(0)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {(mainArticle.comments / 10000).toFixed(1)}万
                  </span>
                  <span>{mainArticle.date}</span>
                </div>
              </div>
            </div>
          </Link>

          {/* Right Side Cards */}
          <div className="w-full lg:w-[45%] flex flex-col gap-4 md:gap-5">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group relative rounded-2xl overflow-hidden flex-1 cursor-pointer"
              >
                <div className="relative h-44 md:h-[248px]">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold mb-2">
                      {article.tag}
                    </span>
                    <h3 className="font-heading text-base md:text-lg text-white group-hover:text-accent-300 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-white/50 text-xs mt-2">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(0)}万
                      </span>
                      <span>{article.date}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {bottomArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="relative h-40 md:h-56">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-500 text-white text-xs font-semibold">
                      {article.category}
                    </span>
                    <span className="text-white/50 text-xs">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-white group-hover:text-accent-300 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}